import React from 'react';
import { NativeSyntheticEvent, TextInput, TextInputChangeEventData } from 'react-native';
import Text, { textVariantStyleMap } from '../Text';
import { colors } from '../../../utils/theme';
import Stack from '../Stack';
import { containerLayout } from './InputBase';

export type NoteTitleInputOwnProps = {
    placeholder: string;
    error?: string;
    value: string | null;
    onChange: (e: NativeSyntheticEvent<TextInputChangeEventData>) => void;
    onBlur?: () => void;
    onFocus?: () => void;
    isDisabled?: boolean;
    testID?: string;
};

export type NoteTitleInputProps = NoteTitleInputOwnProps;

const NoteTitleInput: React.FC<NoteTitleInputProps> = (props) => {
    return (
        <Stack vertical fullWidth align="flex-start" space={1}>
            <TextInput
                style={{
                    height: 40,
                    width: '100%',
                    borderColor: props.error ? colors.Alert : 'transparent',
                    borderWidth: 0,
                    padding: 0,
                    borderRadius: 5,
                    ...containerLayout,
                    ...({ outlineStyle: 'none' } as any),
                    ...textVariantStyleMap[props.value ? 'note-title-value' : 'note-title-placeholder'],
                }}
                placeholder={props.placeholder}
                value={props.value || ''}
                onChange={props.onChange}
                testID={props.testID}
            />
            {props.error ? <Text variant="input-error">{props.error}</Text> : null}
        </Stack>
    );
};

export default React.memo(NoteTitleInput);
